import React, { useEffect, useState } from "react";
import styles from "../money.module.css";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { tableUseStyle } from "../../etc/tableusestyle";
import StyledDataGrid from "../../newtodo/styles/tablestyles";
import { Payment_Student } from "../functions/calcregisterfuncs";
import { Button, Checkbox, Input, Modal, ModalDialog, Radio, RadioGroup } from "@mui/joy";
import { Add, Edit, List, Reorder, Search } from "@mui/icons-material";
import { GridFilterModel, GridRowModel, GridToolbar, useGridApiRef } from "@mui/x-data-grid-premium";
import totalLocationData from "../../../../../data/locationdata";
import { Avatar, CircularProgress, SwipeableDrawer, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import MenuBar from "../../../../../mobile/etc/\bmovingUnderbarMenu";
import { ca, ko } from "date-fns/locale";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PayModal from "../etc/paymodal";
import PaidModal from "../etc/paidmodal";
import { GridSelectionModel } from "@mui/x-data-grid";
import AddGoodModal from "../etc/addgood";
import { connectOrderItemsDataToUser, makeBillId, orderItemsDataUpdatedDataParse } from "../functions/newcalcregisterfuncs";
import { koreanLocationToEnglish } from "../../../../../data/locationFuntion";
import { set, stubTrue } from "lodash";
import { dateToDateString } from "../../etc/etcfunctions";
import NewPayLinkModal from "../etc/newpaylink";

const totalWidth = 1900;

const ManagePayment: React.FC<any> = (props) => {

    const [totalLoading, setTotalLoading] = useState<boolean>(false);
    const [searchText, setSearchText] = useState<string>("");
    const [rows, setRows] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([
        { field: "location", headerName: "지점", width: 100 },
        { field: "seat", headerName: "자리", width: 50 },
        { field: "name", headerName: "이름", width: 100 },
        { field: "payteacherPhoneNumber", headerName: "결제선생 전송번호", width: 180 },
        {
            field: "status", headerName: "잔여상품", width: 150, renderCell: (params: any) => {

                var color = "red";
                var text = "에러상태"

                if (params.value === "unpaid") {
                    color = "#EF4452B2";
                    text = "결제미납"
                }

                if (params.value === "completed") {
                    color = "#0077FFB2";
                    text = "상품없음"
                }

                if (params.value === "imminent") {
                    color = "#FF9C00B2";
                    text = "결제임박"
                }

                // 배지 텍스트 색: 만료된 결제임박이면 빨간색으로 강조
                const textColor = params.row.imminentExpired ? "#EF4452" : "inherit";

                // if (params.value === "scheduled") {
                //     color = "#FF9C00B2";
                //     text = "결제예정"
                // }

                // if (params.value === "refund") {
                //     color = "#0077FFB2";
                //     text = "환불예정"
                // }

                return (
                    <div style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <div style={{
                            width: "90%",
                            height: "90%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: color,
                            borderRadius: "10px",
                            fontFamily: "Apple_SB",
                            color: textColor,
                            fontWeight: params.row.imminentExpired ? "bold" : "normal"
                        }}>
                            {text}
                        </div>
                    </div>
                )


            }
        },
        { field: "billedgood", headerName: "청구상품", width: 200 },
        { field: "sendpays", headerName: "결제선생 전송횟수", width: 120 },
        { field: "holdinggood", headerName: "보유상품", width: 200 },
        { field: "remainingDays", headerName: "잔여일", width: 60 },
        // { field: "firstCome", headerName: "첫등원일", width: 150 },
        // { field: "lastCome", headerName: "마지막등원일", width: 150 },
        {
            field: "firstCome", headerName: "첫등원일", width: 100
        },
        {
            field: "lastCome", headerName: "마지막등원일", width: 100
        },
        {
            field: "memo", headerName: "메모", width: 120, editable: true
        },
        {
            field : "isNow", headerName : "재원생", width : 80
        }
    ]);
    const classes = tableUseStyle();
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [
            {
                id: 1,
                field: "name",
                operator: "contains",
                value: ""
            },
            {
                id: 2,
                field: "payteacherPhoneNumber",
                operator: "contains",
                value: ""
            },
            {
                id: 5,
                field: "location",
                operator: "isAnyOf",
                value: []
            },
            {
                id : 6,
                field : "status",
                operator : "contains",
                value : ""
            },
            {
                id : 7,
                field : "isNow",
                operator : "contains",
                value : "재원생"
            }
        ],
    });
    const [alignment, setAlignment] = useState<string | null>("total");
    const [alignment2, setAlignment2] = useState<string | null>("total");
    const [alignment3, setAlignment3] = useState<boolean>(true);
    const [selectedStudent, setSelectedStudent] = useState<Payment_Student | null>(null);

    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [modalOpen2, setModalOpen2] = useState<boolean>(false);
    const [modalOpen3, setModalOpen3] = useState<boolean>(false);
    const [modalOpen4, setModalOpen4] = useState<boolean>(false);
    const [modalOpen5, setModalOpen5] = useState<boolean>(false);
    const [modalOpen6, setModalOpen6] = useState<boolean>(false);
    const [modalOpen7, setModalOpen7] = useState<boolean>(false);
    const [modalOpen8, setModalOpen8] = useState<boolean>(false);

    const [editPrice, setEditPrice] = useState<number>(0);


    const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
    const [selectedStudentList, setSelectedStudentList] = useState<any[]>([]);

    const [registerPayInfo, setRegisterPayInfo] = useState<any[]>([]);

    const [alreadyHaveUserInfos, setAlreadyHaveUserInfos] = useState<any[]>([]);
    const [duplicateUserInfos, setDuplicateUserInfos] = useState<any[]>([]);
    const [errUserInfos, setErrUserInfos] = useState<any[]>([]);
    const [afterLastDateUserInfos, setAfterLastDateUserInfos] = useState<any[]>([]);

    const apiRef = useGridApiRef();

    const [update, setUpdate] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
    const [payLoading, setPayLoading] = useState<boolean>(false);

    const [selectedPaidOrderItems, setSelectedPaidOrderItems] = useState<any[]>([]);
    const [selectedUnpaidOrderItem, setSelectedUnpaidOrderItem] = useState<any>(null);

    const [totalTeacherData, setTotalTeacherData] = useState<any[]>([]);


    const [selectedStudentLoading, setSelectedStudentLoading] = useState<boolean>(false);

    const [editLoading, setEditLoading] = useState<boolean>(false);
    const [cancelLoading, setCancelLoading] = useState<boolean>(false);

    const [due, setDue] = useState<number>(7);

    const [ratio, setRatio] = useState<string>("수기입력");

    const [separateCount, setSeparateCount] = useState<number>(1);
    const [separateCountValues, setSeparateCountValues] = useState<number[]>([]);
    const [separateCountLoading, setSeparateCountLoading] = useState<boolean>(false);
    const [separateDisabled, setSeparateDisabled] = useState<boolean>(false);

    const letsUpdate = () => {

        setUpdate(Math.random());

    }

    const handleClose = (action = "", duplicateUserInfos = [], errUserInfos = []) => {
        setModalOpen(false);
    }

    const handleClose2 = () => {
        setModalOpen2(false);
    }

    const handleClose3 = () => {
        setModalOpen3(false);
    }

    const handleClose4 = () => {

        setDuplicateUserInfos([]);
        setErrUserInfos([]);
        setAlreadyHaveUserInfos([]);
        setAfterLastDateUserInfos([]);

        setModalOpen4(false);
    }

    const handleClose5 = () => {

        setModalOpen5(false);
        setDue(7);

    }

    const handleClose6 = () => {
        setModalOpen6(false);
    }

    const handleClose7 = () => {
        setSeparateCount(1);
        setSeparateCountValues([]);
        setSeparateDisabled(false);
        setModalOpen7(false);
    }

    useEffect(() => {

        if (modalOpen7) {
        
            setSeparateCountValues([]);
            setSeparateDisabled(false);
            setSeparateCount(1);
        
        }

    }, [modalOpen7]);

    const getTotalUserList = async () => {

        //수강료 리스트 가져오기
        //환불내역 정보 가져오기
        //학생들 리스트 가져오기 (재원생)
        //미납 리스트 가져오기

        try {

            if (update === 0) {
                setTotalLoading(true);
            }

            const result: any = await getFetch("/dashboard/payments/managepayment/gettotaluserlist");

            const { totalUser, registerPayInfo, teacherData, orderItemsData } = result;

            setTotalTeacherData(teacherData);

            setRegisterPayInfo([...registerPayInfo]);

            orderItemsDataUpdatedDataParse(orderItemsData, teacherData);
            connectOrderItemsDataToUser(totalUser, orderItemsData);

            console.log(totalUser);

            makeRows(totalUser);

            setTotalLoading(false);


        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {

        getTotalUserList();

    }, [update]);

    const makeRows = (totalUser: Array<Payment_Student>) => {

        const newRows: any = [];

        totalUser.sort((a: any, b: any) => {
            if (!a.location && b.location) return -1;
            if (a.location && !b.location) return 1;

            if (a.location !== b.location) {
                return a.location.localeCompare(b.location);
            }

            if (!a.seat && b.seat) return -1;
            if (a.seat && !b.seat) return 1;
            if (!a.seat && !b.seat) return 0;

            return Number(a.seat) - Number(b.seat);
        });

        totalUser.forEach((user: any) => {

            const oneRow: any = {}

            if (user.name === "고용범2호점") {
                console.log("paymentMemo");
                console.log(user.paymentsMemo);
            }

            oneRow.id = user.id;
            oneRow.location = user.location;
            //재학생이면 표시용 이름에만 (재학생) 붙임 (oneRow.student 원본은 결제링크 발송에 쓰이므로 건드리지 않음)
            oneRow.name = user.isEnrolledStudent === 1 ? user.name + " (재학생)" : user.name;
            oneRow.isNow = user.isNow ? "재원생" : "퇴원생";
            oneRow.phoneNumber = user.phoneNumber;
            oneRow.memo = user.paymentsMemo;
            oneRow.seat = user.seat;
            oneRow.payteacherPhoneNumber = user.payteacherPhoneNumber ? user.payteacherPhoneNumber : user.parentPhoneNumber ? user.parentPhoneNumber : user.phoneNumber;
            oneRow.sendpays = user.unpaidOrderItem && user.unpaidOrderItem.payteacher_send_count ? user.unpaidOrderItem.payteacher_send_count : 0;

            if (user.unpaidOrderItem) {
                oneRow.status = "unpaid";
            } else {
                oneRow.status = "completed";
            }

            if (user.unpaidOrderItem) {

                var string = "";

                const startDate = new Date(user.unpaidOrderItem.startDate);
                const endDate = new Date(user.unpaidOrderItem.endDate);

                //~월~일 - ~월~일
                string += `${startDate.getMonth() + 1}월 ${startDate.getDate()}일 - ${endDate.getMonth() + 1}월 ${endDate.getDate()}일`;

                //price int값 콤마찍고 (원) 붙이기
                string += ` (${user.unpaidOrderItem.price ? user.unpaidOrderItem.price.toLocaleString("ko-KR") : 0}원)`;
                oneRow.billedgood = string;
                oneRow.productName = `${startDate.getMonth() + 1}월 ${startDate.getDate()}일 - ${endDate.getMonth() + 1}월 ${endDate.getDate()}일 수강료`;
            }

            if (user.paidOrderItems && user.paidOrderItems.length > 0) {

                var string = "";

                const firstPaidItem = user.paidOrderItems[0];

                const startDate = new Date(firstPaidItem.startDate);
                const endDate = new Date(firstPaidItem.endDate);

                string = `${startDate.getMonth() + 1}월 ${startDate.getDate()}일 - ${endDate.getMonth() + 1}월 ${endDate.getDate()}일`;
                //월 일 한자리 수 일때는 앞에 0 붙이기
                string = `${startDate.getMonth() + 1 < 10 ? '0' + (startDate.getMonth() + 1) : startDate.getMonth() + 1}월 ${startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate()}일 - ${endDate.getMonth() + 1 < 10 ? '0' + (endDate.getMonth() + 1) : endDate.getMonth() + 1}월 ${endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate()}일`;

                //price int값 콤마찍고 (원) 붙이기
                string += ` (${firstPaidItem.price ? firstPaidItem.price.toLocaleString("ko-KR") : 0}원)`;
                oneRow.holdinggood = string;

                //잔여일 계산
                const today = new Date();
                const timeDiff = endDate.getTime() - today.getTime();
                const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

                oneRow.remainingDays = dayDiff > 0 ? (dayDiff < 10 ? "0" + dayDiff : dayDiff) + "일" : 0 + "일";

                // 결제임박: 청구상품(unpaidOrderItem) 없고 잔여일 7일 이하 (만료 포함)
                if (!user.unpaidOrderItem && dayDiff <= 7) {
                    oneRow.status = "imminent";
                    // 이미 만료(잔여일 0일 이하)면 배지 글씨를 빨간색으로 강조
                    if (dayDiff <= 0) {
                        oneRow.imminentExpired = true;
                    }
                }

            }

            if (user.firstCome) {
                const firstDate = new Date(user.firstCome);
                oneRow.firstCome = `${firstDate.getMonth() + 1}월 ${firstDate.getDate()}일`;
                //한자리 수이면 앞에 0 붙이기
                oneRow.firstCome = `${firstDate.getMonth() + 1 < 10 ? '0' + (firstDate.getMonth() + 1) : firstDate.getMonth() + 1}월 ${firstDate.getDate() < 10 ? '0' + firstDate.getDate() : firstDate.getDate()}일`;
            }

            if (user.lastCome && user.firstCome) {

                const firstComeTime = new Date(user.firstCome).getTime();

                const lastDate = new Date(user.lastCome);
                const lastDateTime = lastDate.getTime();

                if (lastDateTime < firstComeTime) {
                    oneRow.lastCome = "";
                } else {
                    oneRow.lastCome = `${lastDate.getMonth() + 1}월 ${lastDate.getDate()}일`;
                    //한자리 수이면 앞에 0 붙이기
                    oneRow.lastCome = `${lastDate.getMonth() + 1 < 10 ? '0' + (lastDate.getMonth() + 1) : lastDate.getMonth() + 1}월 ${lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate()}일`;
                }
            }

            oneRow.student = user;

            newRows.push(oneRow);
        })

        setRows([...newRows]);

    }

    const handleTextChange = (e: any) => {

        var isZero = false;
        var isNumber = false;

        if (e.target.value.length === 0) {
            isZero = true;
        }

        //e.target.value의 첫번째 글자가 숫자인지 확인
        if (!isZero && !isNaN(+e.target.value[0])) {
            isNumber = true;
        }

        setSearchText(e.target.value);

        const newFilterModel: any = { ...filterModel };

        if (!isZero && !isNumber) {
            newFilterModel.items.forEach((each: any) => {
                if (each.id === 1) {
                    each.value = e.target.value;
                }
            })
        }

        if (!isZero && isNumber) {
            newFilterModel.items.forEach((each: any) => {
                if (each.id === 2) {
                    each.value = e.target.value;
                }
            })
        }
        if (isZero) {
            newFilterModel.items.forEach((each: any) => {
                if (each.id === 1 || each.id === 2) {
                    each.value = "";
                }
            })
        }

        setFilterModel({ ...newFilterModel });
    }

    const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {

        if (!newAlignment) return;

        setAlignment(newAlignment);

        const newFilterModel: any = { ...filterModel };

        const locationList: any = [];

        totalLocationData.forEach((location) => {

            if (newAlignment === "total") {


            } else if (location.english === newAlignment) {
                locationList.push(location.korean);
            }

        });

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 5) {
                each.value = locationList;
            }
        })



        setFilterModel({ ...newFilterModel });
    }

    const handleChange2 = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {

        if (!newAlignment) return;

        setAlignment2(newAlignment);

        const newFilterModel: any = filterModel;

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 6) {
                if (newAlignment === "total") {
                    each.value = "";
                } else if (newAlignment === "notPaid") {
                    each.value = "unpaid";
                } else if (newAlignment === "imminent") {
                    each.value = "imminent";
                } else if (newAlignment === "noGood") {
                    each.value = "completed";
                }
            }

        })

        setFilterModel({ ...newFilterModel });

    }

    const handleChange3 = (event: React.MouseEvent<HTMLElement>, newAlignment: boolean | null) => {

        if (newAlignment === null || newAlignment === undefined) return;

        setAlignment3(newAlignment);

        const newFilterModel: any = filterModel;

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 7) {
                if (newAlignment === true) {
                    each.value = "재원생";
                } else {
                    each.value = "퇴원생";
                }
            }

        })

        setFilterModel({ ...newFilterModel });

    }



    useEffect(() => {

        setSelectedUnpaidOrderItem(null);

        if (!selectedStudent) return;

        console.log("selected Student");

        console.log(selectedStudent);

        getSelectedStudentInfo();


    }, [selectedStudent, update]);


    const getSelectedStudentInfo = async () => {

        try {

            if (!selectedStudent) {
                return;
            }

            setSelectedStudentLoading(true);

            const result: any = await getFetch("/dashboard/payments/managepayment/getselectedstudentinfo?userId=" + selectedStudent.id);

            console.log(result);

            setSelectedStudentLoading(false);

            if (result.message === "success") {
                const data = result.data;

                orderItemsDataUpdatedDataParse(data.orderItemsData ? data.orderItemsData : [], totalTeacherData);
                orderItemsDataUpdatedDataParse(data.unpaidOrderItem ? [data.unpaidOrderItem] : [], totalTeacherData);

                if (data.orderItemsData) {
                    setSelectedPaidOrderItems([...data.orderItemsData]);
                } else {
                    setSelectedPaidOrderItems([]);
                }

                if (data.unpaidOrderItem) {
                    setSelectedUnpaidOrderItem({...data.unpaidOrderItem});
                } else {
                    setSelectedUnpaidOrderItem(null);
                }
            }

        } catch (e) {
            console.log(e);
        }

    }

    const notify7 = () => toast.success("결제가 완료되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify8 = () => toast.error("결제 취소에 실패했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify9 = () => toast.success("결제 취소에 성공했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify16 = () => toast.success("결제취소 예정으로 변경되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify10 = () => toast.error("청구상품 삭제에 실패했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify11 = () => toast.success("청구상품 삭제에 성공했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify12 = () => toast.error("삭제할 청구 상품이 없습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify13 = () => toast.success("금액을 수정했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify14 = () => toast.success("결제링크 파기가 완료되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notify15 = () => toast.success("청구상품 결제가 취소되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notify17 = () => toast.success("링크가 클립보드에 복사되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notify18 = () => toast.success("환불 청구상품이 생성되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    useEffect(() => {

        const selectedStudents: any[] = [];

        selectionModel.forEach((selectedId) => {

            const selectedRow = apiRef.current.getRow(selectedId);

            if (selectedRow) {
                selectedStudents.push(selectedRow.student);
            }

        })

        setSelectedStudentList([...selectedStudents]);

    }, [selectionModel, rows]);

    const deleteOrderItems = async () => {
        try {

            if (!window.confirm("선택 된 학생들의 청구상품을 삭제하시겠습니까?")) {
                return;
            }

            if (selectionModel.length === 0) {
                return;
            }

            const selectedOrderItemsIds: number[] = [];

            selectionModel.forEach((selectedId) => {

                const selectedRow = apiRef.current.getRow(selectedId);

                if (selectedRow && selectedRow.student && selectedRow.student.unpaidOrderItem) {
                    selectedOrderItemsIds.push(selectedRow.student.unpaidOrderItem.id);
                }

            });

            if (selectedOrderItemsIds.length === 0) {
                notify12();
                return;
            }

            setDeleteLoading(true);

            const result: any = await postFetch("/dashboard/payments/managepayment/deleteorderitems", {
                orderItemsIds: selectedOrderItemsIds
            });

            console.log(result);

            setDeleteLoading(false);

            if (result.message === "success") {
                notify11();
                letsUpdate();
            } else {
                notify10();
                letsUpdate();
            }

        } catch (e) {
            console.log(e);
        }
    }

    const sendPayTeacher = async () => {

        try {

            if (!window.confirm("선택 된 학생들 청구상품에 대해 결제선생을 전송하시겠습니까?")) {
                return;
            }

            setPayLoading(true);

            if (selectionModel.length === 0) {
                setPayLoading(false);
                return;
            }

            const postData: any = [];

            selectionModel.forEach((selectedId) => {

                const data: any = {};

                const selectedRow = apiRef.current.getRow(selectedId);

                console.log(selectedRow);

                if (selectedRow && selectedRow.student && selectedRow.student.unpaidOrderItem) {

                    data.orderItemId = selectedRow.student.unpaidOrderItem.id;
                    data.location = koreanLocationToEnglish(selectedRow.location) || "";

                    if (!data.location) {
                        return;
                    }

                    data.product_nm = selectedRow.productName;
                    data.message = selectedRow.productName;
                    data.member_nm = selectedRow.student.name;
                    data.phone = selectedRow.payteacherPhoneNumber;

                    data.due = due;

                    if(selectedRow.student.unpaidOrderItem.separateValues){
                        const separateValues = selectedRow.student.unpaidOrderItem.separateValues;

                        separateValues.forEach((value : any, index : number) => {

                            postData.push({
                                ...data,
                                price : value,
                                isSeparate : true
                            })


                        });

                        return;

                    }

                    data.price = selectedRow.student.unpaidOrderItem.price;
                    postData.push(data);
                }

            });

            console.log(postData);

            const result: any = await postFetch("/dashboard/payments/managepayment/sendpaylinktostudents", {
                postData: postData
            });

            setPayLoading(false);

            console.log(result);

            if (result.message === "success") {

                const data = result.data;

                const success = data.success;
                const fail = data.fail;

                toast.success(`
                성공: ${success}건, 실패: ${fail}건
                `, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    theme: "light"
                })

                letsUpdate();
                handleClose5();

            }

        } catch (e) {
            console.log(e);
        }

    }

    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {
            var field = "";


            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) {
                    field = key;

                }
            }

            const cellValue = newRow[field] ? newRow[field] : "";

            if (field === "memo") {

                fetch("https://peetsunbae.com/dashboard/payments/managepayment/updatememo", {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({
                        id: newRow.id,
                        value: cellValue,
                        field
                    })
                }).then((response: any) => {
                    response.json()
                        .then((result: any) => {

                        })
                })
            }

            return newRow;
        }, []
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {

        alert(error.message);
    }, []);

    const formatNumber = (value: number | string) => {
        if (value === '' || value === null || value === undefined) return '';
        return Number(value).toLocaleString('ko-KR');
    };

    const unformatNumber = (value: string) => {
        return Number(value.replace(/,/g, ''));
    };

    const saveEditedPrice = async () => {

        try {

            setEditLoading(true);

            console.log("saveEditedPrice");
            console.log(selectedUnpaidOrderItem);

            if (!selectedUnpaidOrderItem) {
                setEditLoading(false);
                return;
            }

            if (editPrice <= 0) {
                alert("수정 금액은 0원보다 커야 합니다.");
                setEditLoading(false);
                return;
            }

            const result: any = await postFetch("/dashboard/payments/managepayment/editsingleunpaidorderitemprice", {
                orderItemId: selectedUnpaidOrderItem.id,
                newPrice: editPrice
            });

            console.log(result);

            if (result.message === "success") {

                notify13();
                letsUpdate();
                setModalOpen6(false);
                setRatio("수기입력");
                setEditPrice(0);

            }

            setEditLoading(false);

        } catch (e) {
            console.log(e);
        }

    };

    useEffect(() => {

        if (modalOpen6) {
            if (selectedUnpaidOrderItem) {
                setRatio("수기입력");
                setEditPrice(selectedUnpaidOrderItem.price);
            }
        } else {
            setEditPrice(0);
        }

    }, [modalOpen6]);


    const destroyOrCancel = async (type: string, billId: string) => {

        try {

            var confirmText = type === "destroy" ? "해당 결제링크를 파기시겠습니까?" : "해당 청구상품의 결제를 취소시키겠습니까?";

            if (!window.confirm(confirmText)) {
                return;
            }

            setCancelLoading(true);

            console.log({
                type: type,
                billId: billId
            });

            const result: any = await postFetch("/dashboard/payments/managepayments/destroyorcancelpaymentlink", {
                type: type,
                billId: billId
            });

            setCancelLoading(false);

            console.log(result);

            if (result.message === "success") {

                if (type === "destroy") {
                    notify14();
                } else {
                    notify15();
                }

                letsUpdate();

            }else{
                alert(result.detail);
            }

        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {

        var total = 0;

        separateCountValues.forEach((value) => {
            if(!value) return;

            total += Number(value);

        });

        const price = selectedUnpaidOrderItem ? selectedUnpaidOrderItem.price : 0;

        if(total >= price){
            setSeparateDisabled(true);
        }else{
            setSeparateDisabled(false);
        }

    }, [separateCountValues, selectedUnpaidOrderItem]);

    const saveSeparatePrice = async () => {

        try{

            if(!selectedUnpaidOrderItem){
                return;
            }

            setSeparateCountLoading(true);

            const price = selectedUnpaidOrderItem ? selectedUnpaidOrderItem.price : 0;

            var total = 0;

            separateCountValues.forEach((value) => {
                if(!value) return;

                total += Number(value);

            });

            const differecne = price - total;

            console.log(differecne);

            console.log(separateCountValues);

            //맨 마지막에 차액 넣기
            const newSeparateCountValues = [...separateCountValues];
            newSeparateCountValues.push(differecne);

            console.log("saveSeparatePrice");
            console.log(newSeparateCountValues);
            console.log(separateCount);

            const result : any = await postFetch("/dashboard/payments/managepayment/separateunpaidorderitemprice", {
                orderItemId: selectedUnpaidOrderItem.id,
                separateValues: newSeparateCountValues,
                separateCount
            });

            console.log(result);

            setSeparateCountLoading(false);

            if(result.message === "success"){
                
                notify13();
                letsUpdate();
                setModalOpen7(false);
                setSeparateCount(1);
                setSeparateCountValues([]);
            }


        }catch(e){
            console.log(e);
        }

    }



    return (
        <div style={{
            paddingTop: "40px"
        }}>
            <div style={{
                width: `${totalWidth}px`,
                marginBottom: "20px"
            }}>
                <Input
                    fullWidth
                    startDecorator={<Search />}
                    placeholder="이름 또는 전화번호"
                    variant="outlined"
                    size="lg"
                    value={searchText}
                    onChange={handleTextChange}
                />
            </div>
            <div style={{
                width: `${totalWidth}px`,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px"
                }}>
                    <div>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment}
                            exclusive
                            onChange={handleChange}
                        >
                            {
                                props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {
                                    return (
                                        <ToggleButton value={each.english} key={index}>{each.korean}</ToggleButton>
                                    )
                                })
                            }
                        </ToggleButtonGroup>
                    </div>

                </div>
            </div>
            <div style={{
                width: `${totalWidth}px`,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px"
                }}>
                    <div>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment2}
                            exclusive
                            onChange={handleChange2}
                        >
                            <ToggleButton value="total">전체</ToggleButton>
                            <ToggleButton value="notPaid">결제미납</ToggleButton>
                            <ToggleButton value="imminent">결제임박</ToggleButton>
                            <ToggleButton value="noGood">상품없음</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment3}
                            exclusive
                            onChange={handleChange3}
                        >
                            <ToggleButton value={true}>재원생</ToggleButton>
                            <ToggleButton value={false}>비재원생</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div style={{
                        fontFamily: "Apple_SB",
                    }}>
                        선택 된 학생 수 : {selectionModel.length}명
                    </div>
                </div>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <div>
                        {/* <Button
                            variant="solid"
                            onClick={() => {
                                setModalOpen8(true);
                            }}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                        >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                            }}>
                                신규 결제링크 만들기
                            </div>
                        </Button> */}
                        <Button
                            variant="solid"
                            onClick={() => {
                                deleteOrderItems();
                            }}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                            disabled={selectionModel.length === 0 || deleteLoading}
                            loading={deleteLoading}
                        >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                            }}>
                                청구상품 삭제하기
                            </div>
                        </Button>
                        <Button
                            variant="solid"
                            onClick={() => {
                                setModalOpen5(true);
                            }}
                            color="neutral"
                            style={{
                                marginRight: "10px"
                            }}
                            disabled={selectionModel.length === 0 || deleteLoading}
                            loading={deleteLoading}
                        >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                            }}>
                                결제선생 전송하기
                            </div>
                        </Button>
                        <Button
                            variant="solid"
                            onClick={() => {

                                setDuplicateUserInfos([]);
                                setErrUserInfos([]);
                                setAlreadyHaveUserInfos([]);
                                setAfterLastDateUserInfos([]);

                                setModalOpen(true);
                            }}
                            color="primary"
                            disabled={selectionModel.length === 0}
                        >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                            }}>
                                청구상품 추가하기
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
            <div className={classes.root} style={{
                height: "900px", width: `${totalWidth}px`,
                display: "flex",
                justifyContent: "space-between"
            }}>
                <div style={{
                    backgroundColor: "white",
                    marginRight : "15px"
                }}>
                    <StyledDataGrid
                        rows={rows}
                        columns={columns}
                        density='compact'
                        hideFooter
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    phoneNumber: false
                                }
                            }
                        }}
                        disableRowSelectionOnClick
                        filterModel={filterModel}
                        onFilterModelChange={(newFilterModel) => {
                            setFilterModel(newFilterModel);
                        }}
                        onRowClick={(e) => {
                            console.log("row clicked");
                            console.log(e.row.student);
                            setSelectedStudent(e.row.student);
                        }}
                        checkboxSelection={true}
                        rowSelectionModel={selectionModel}
                        onRowSelectionModelChange={(newSelectionModel) => {
                            console.log("newSelectionModel");
                            console.log(newSelectionModel);
                            setSelectionModel(newSelectionModel);
                        }}
                        isRowSelectable={(params) => {
                            if (params.row.location) {
                                return true;
                            } else {
                                return false;
                            }
                        }}
                        apiRef={apiRef}
                        loading={totalLoading}
                        processRowUpdate={handleEditCommit}
                        onProcessRowUpdateError={handleProcessRowUpdateError}
                        components={{
                            Toolbar : GridToolbar
                        }}
                        columnVisibilityModel={{
                            isNow : false
                        }}
                        
                    />
                </div>
                <div style={{
                    width: "450px",
                    backgroundColor: "white",
                    paddingLeft: "24px",
                    paddingRight: "24px",
                    paddingTop: "24px",
                    paddingBottom: "24px",
                    position: "relative",
                }}>
                    {
                        (selectedStudent) &&
                        <div>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    marginRight: "12px"
                                }}>
                                    <Avatar sx={{ bgcolor: "#b0dbf1" }}><img src="img/user-solid.svg" alt="user" className="avatarImg" /></Avatar>
                                </div>
                                <div style={{
                                    fontFamily: "Apple_SB",
                                    fontSize: "20px",
                                    color: "#575757"
                                }}>
                                    {selectedStudent.name} 학생
                                </div>

                            </div>
                            {/* <div style={{
                                width: "100%",
                                marginTop: "18px"
                            }}>
                                <MenuBar
                                    menuItems={[
                                        {
                                            key: "register",
                                            label: "등록비"
                                        },
                                        {
                                            key: "contents",
                                            label: "컨텐츠"
                                        }
                                    ]}
                                    handleCurrentMenu={(menu: string) => {
                                        console.log(menu);
                                        setCurrentMenu(menu);
                                    }}
                                />
                            </div> */}
                            <div style={{
                                fontFamily: "Apple_R",
                                marginTop: "24px"
                            }}>
                                <div>
                                    <div style={{
                                        width: "100%",
                                        borderBottom: "1px solid #8B8B8B",
                                        marginTop: "16px",
                                        marginBottom: "16px"
                                    }}>
                                    </div>
                                    <div style={{
                                        marginTop: "16px",
                                        display: "flex",
                                    }}>
                                        <div style={{
                                            marginRight: "90px",
                                            width: "60px",
                                        }}>
                                            지점
                                        </div>
                                        <div>
                                            {selectedStudent.location}
                                        </div>
                                    </div>
                                    <div style={{
                                        marginTop: "16px",
                                        display: "flex",

                                    }}>
                                        <div style={{
                                            marginRight: "90px",
                                            width: "60px",
                                        }}>
                                            자리
                                        </div>
                                        <div>
                                            {selectedStudent.seat}
                                        </div>
                                    </div>
                                    <div style={{
                                        marginTop: "16px",
                                        display: "flex",
                                    }}>
                                        <div style={{
                                            marginRight: "90px",
                                            width: "60px",
                                        }}>
                                            연락처
                                        </div>
                                        <div>
                                            {selectedStudent.phoneNumber}
                                        </div>
                                    </div>
                                </div>
                                <div style={{
                                    width: "100%",
                                    borderBottom: "1px solid #8B8B8B",
                                    marginTop: "16px",
                                    marginBottom: "16px"
                                }}>
                                </div>
                                {
                                    selectedStudentLoading ?
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "200px"
                                        }}>
                                            <CircularProgress />
                                        </div>
                                        :
                                        <>
                                            <div style={{
                                                marginBottom: "28px"
                                            }}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                }}>
                                                    <div style={{
                                                        fontFamily: "Apple_SB",
                                                        fontSize: "24px"
                                                    }}>
                                                        청구상품
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        alignContent: "center",
                                                        fontSize: "20px",
                                                        cursor: "pointer",
                                                    }}
                                                        onClick={(e: any) => {
                                                            setModalOpen3(true);
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                marginRight: "8px"
                                                            }}
                                                        >결제 내역</span> <Reorder />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{
                                                height : "520px",
                                                overflowY : "auto",
                                                scrollbarWidth: "none",
                                                msOverflowStyle: "none",
                                            }}>
                                                <div style={{
                                                    fontFamily: "Apple_SB",
                                                    marginBottom: "16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}>
                                                    청구상품 내역
                                                    {
                                                        selectedUnpaidOrderItem
                                                            ?
                                                            <span style={{
                                                                marginLeft: "12px",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}
                                                                onClick={() => {
                                                                    setModalOpen6(true);
                                                                }}
                                                            >
                                                                <Edit
                                                                    fontSize="small"
                                                                />
                                                            </span>
                                                            :
                                                            ""
                                                    }
                                                </div>
                                                <div>
                                                    {
                                                        selectedUnpaidOrderItem
                                                            ?
                                                            <>
                                                                <div>
                                                                    <div>
                                                                        {new Date(selectedUnpaidOrderItem.startDate).getMonth() + 1}월 {new Date(selectedUnpaidOrderItem.startDate).getDate()}일 - {new Date(selectedUnpaidOrderItem.endDate).getMonth() + 1}월 {new Date(selectedUnpaidOrderItem.endDate).getDate()}일 ({selectedUnpaidOrderItem.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원)
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            "청구된 상품이 없습니다."
                                                    }
                                                </div>
                                                <div style={{
                                                    fontFamily: "Apple_SB",
                                                    marginBottom: "12px",
                                                    marginTop: "32px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}>
                                                    분할 결제
                                                    <span style={{
                                                        marginLeft: "12px",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                        onClick={() => {
                                                            setModalOpen7(true);
                                                        }}
                                                    >
                                                        <Edit
                                                            fontSize="small"
                                                        />
                                                    </span>
                                                </div>
                                                <div>
                                                    {
                                                        (selectedUnpaidOrderItem && selectedUnpaidOrderItem.separateValues && selectedUnpaidOrderItem.separateValues.length > 0) ?
                                                        selectedUnpaidOrderItem.separateValues.map((each : number, index : number) => {
                                                            return (
                                                                <div key={index} style={{
                                                                    marginBottom: "8px",
                                                                }}>
                                                                    ({index + 1}) {each.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        ""
                                                    }
                                                </div>
                                                <div style={{
                                                    fontFamily: "Apple_SB",
                                                    marginBottom: "12px",
                                                    marginTop: "32px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}>
                                                    결제선생 발송 내역
                                                </div>
                                                <div style={{
                                                }}>
                                                    {
                                                        (selectedUnpaidOrderItem && selectedUnpaidOrderItem.payteacherData) ?
                                                            selectedUnpaidOrderItem.payteacherData.map((each: any, index: number) => {
                                                                return (
                                                                    <div key={each.id} style={{
                                                                        marginBottom: "16px",
                                                                    }}>
                                                                        <div style={{
                                                                            fontFamily: "Apple_SB",
                                                                        }}>
                                                                            ({index + 1}) {dateToDateString(new Date(each.createdAt), true)} 발송내역
                                                                            <span style={{
                                                                                marginLeft: "6px",
                                                                                display: "inline-flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                {
                                                                                    each.appr_state === "W"
                                                                                    &&
                                                                                    <Button
                                                                                        variant="soft"
                                                                                        color="neutral"
                                                                                        size="sm"
                                                                                        onClick={() => {
                                                                                            const bill_id = makeBillId(each.businessNumber, each.id);
                                                                                            destroyOrCancel("destroy", bill_id);
                                                                                        }}
                                                                                        loading={cancelLoading}
                                                                                    >
                                                                                        파기하기
                                                                                    </Button>
                                                                                }
                                                                                {
                                                                                    each.appr_state === "F"
                                                                                    &&
                                                                                    <Button
                                                                                        variant="soft"
                                                                                        color="neutral"
                                                                                        size="sm"
                                                                                        onClick={() => {
                                                                                            const bill_id = makeBillId(each.businessNumber, each.id);
                                                                                            destroyOrCancel("cancel", bill_id);
                                                                                        }}
                                                                                        loading={cancelLoading}
                                                                                    >
                                                                                        취소시키기
                                                                                    </Button>
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                        <div style={{
                                                                            marginTop: "4px"
                                                                        }}>
                                                                            - 사업자번호 : {each.businessNumber}
                                                                        </div>
                                                                        <div style={{
                                                                            marginTop: "4px"
                                                                        }}>
                                                                            - 가격 : {each.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원
                                                                        </div>
                                                                        <div style={{
                                                                            marginTop: "4px"
                                                                        }}>
                                                                            - 기한 : {dateToDateString(new Date(new Date(each.createdAt).setDate(new Date(each.createdAt).getDate() + each.due)))}
                                                                        </div>
                                                                        <div style={{
                                                                            marginTop: "4px"
                                                                        }}>
                                                                            {/* //F : 결제완료, W : 미결제, C : 결제취소, D : 파기 */}
                                                                            - 현재 상태 : {each.appr_state === "F" ? "결제완료" : each.appr_state === "W" ? "미결제" : each.appr_state === "C" ? "결제취소" : each.appr_state === "D" ? "파기" : each.appr_state}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                            :
                                                            ""
                                                    }
                                                </div>
                                            </div>
                                        </>
                                }

                            </div>
                        </div>
                    }
                    {
                        (selectedStudent && selectedUnpaidOrderItem)
                        &&
                        <div style={{
                            position: "absolute",
                            bottom: "24px",
                            width: "calc(100% - 48px)",
                        }}>
                            <div style={{
                                marginTop: "12px",
                            }}>
                                <Button
                                    fullWidth
                                    variant="solid"
                                    size="lg"
                                    disabled={selectedStudent === null}
                                    onClick={() => {
                                        setModalOpen2(true);
                                    }}
                                >
                                    {selectedUnpaidOrderItem.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원 결제하기
                                </Button>
                            </div>
                        </div>

                    }

                </div>
            </div>



            <AddGoodModal
                open={modalOpen}
                handleClose={handleClose}
                letsUpdate={letsUpdate}
                selectedStudentList={selectedStudentList}
                registerPayInfo={registerPayInfo}
                setModalOpen4={setModalOpen4}
                setDuplicateUserInfos={setDuplicateUserInfos}
                setErrUserInfos={setErrUserInfos}
                setAlreadyHaveUserInfos={setAlreadyHaveUserInfos}
                setAfterLastDateUserInfos={setAfterLastDateUserInfos}
                setUpdate={setUpdate}
            />
        
            <NewPayLinkModal
                open={modalOpen8}
                handleClose={() => setModalOpen8(false)}
                registerPayInfo={registerPayInfo}
                notify17={notify17}
            />

            <PayModal
                open={modalOpen2}
                handleClose={handleClose2}
                selectedStudent={selectedStudent}
                selectedUnpaidOrderItem={selectedUnpaidOrderItem}
                notify={notify7}
                setUpdate={setUpdate}
            />

            <PaidModal
                open={modalOpen3}
                handleClose={handleClose3}
                userId={selectedStudent ? selectedStudent.id : 0}
                selectedPaidOrderItems={selectedPaidOrderItems}
                notify8={notify8}
                notify9={notify9}
                notify16={notify16}
                setUpdate={setUpdate}
                update={update}
                totalTeacherData={totalTeacherData}
                registerPayInfo={registerPayInfo}
                selectedStudent={selectedStudent}
                notify18={notify18}
            />

            <Modal
                open={modalOpen7}
                onClose={handleClose7}
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: "none",
                            backgroundColor: "transparent",
                        },
                    },
                }}
            >
                <ModalDialog>
                    <div style={{
                        width: "300px"
                    }}>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "20px",
                            marginBottom: "12px"
                        }}>
                            분할 결제 설정
                        </div>
                        <div style={{
                            marginBottom: "12px"
                        }}>
                            <RadioGroup
                                orientation="horizontal"
                                aria-labelledby="segmented-controls-example"
                                name="ratio"
                                value={separateCount.toString()}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    const count = parseInt(event.target.value);
                                    setSeparateCount(count);
                                }
                                }
                                sx={{
                                    minHeight: 48,
                                    padding: '4px',
                                    borderRadius: '12px',
                                    bgcolor: 'neutral.softBg',
                                    '--RadioGroup-gap': '4px',
                                    '--Radio-actionRadius': '8px',
                                }}
                            >
                                {["1", "2", "3", "4", "5"].map((item) => (
                                    <Radio
                                        key={item}
                                        color="neutral"
                                        value={item}
                                        disableIcon
                                        label={item + "개"}
                                        variant="plain"
                                        sx={{ px: 2, alignItems: 'center' }}
                                        slotProps={{
                                            action: ({ checked }) => ({
                                                sx: {
                                                    ...(checked && {
                                                        bgcolor: 'background.surface',
                                                        boxShadow: 'sm',
                                                        '&:hover': {
                                                            bgcolor: 'background.surface',
                                                        },
                                                    }),
                                                },
                                            }),
                                        }}
                                    />
                                ))}
                            </RadioGroup>
                        </div>
                        {
                            new Array(separateCount - 1).fill(0).map((value, index) => (
                                <div key={index} style={{
                                    marginBottom: "12px"
                                }}>
                                    <div style={{
                                        marginBottom: "4px"
                                    }}>
                                        {index + 1}번째 금액
                                    </div>
                                    <Input
                                        fullWidth
                                        type="text"
                                        value={formatNumber(separateCountValues[index] || 0)}
                                        onChange={(e) => {
                                            const rawValue = e.target.value;
                                            const numericValue = unformatNumber(rawValue);

                                            if (!isNaN(numericValue)) {
                                                const newValues = [...separateCountValues];
                                                newValues[index] = numericValue;
                                                setSeparateCountValues(newValues);
                                            }
                                        }}
                                        endDecorator={<span>원</span>}
                                    />
                                </div>
                            ))  
                        }
                        <div style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "24px"
                        }}>
                            <Button
                                variant="solid"
                                onClick={saveSeparatePrice}
                                loading={separateCountLoading}
                                disabled={separateDisabled}
                            >
                                저장하기
                            </Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>

            <Modal
                open={modalOpen6}
                onClose={handleClose6}
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: "none",
                            backgroundColor: "transparent",
                        },
                    },
                }}
            >
                <ModalDialog>
                    <div style={{
                        width: "300px"
                    }}>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "20px",
                            marginBottom: "12px"
                        }}>
                            청구상품 가격 수정
                        </div>
                        <div style={{
                            marginBottom: "12px"
                        }}>
                            <RadioGroup
                                orientation="horizontal"
                                aria-labelledby="segmented-controls-example"
                                name="ratio"
                                value={ratio}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {


                                    const location = selectedStudent ? selectedStudent.location : "";

                                    if (!location) {
                                        return;
                                    }
                                    console.log(location);
                                    const englishLocation = koreanLocationToEnglish(location);
                                    console.log(registerPayInfo);

                                    const basePrice = registerPayInfo.find((info) => info.location === englishLocation)?.price || 0;

                                    if (!basePrice) {
                                        return;
                                    }

                                    switch (event.target.value) {
                                        case "1/3":
                                            setEditPrice(Math.floor(basePrice / 3 / 10) * 10);
                                            break;
                                        case "1/2":
                                            setEditPrice(Math.floor(basePrice / 2 / 10) * 10);
                                            break;
                                        case "2/3":
                                            setEditPrice(Math.floor((basePrice * 2 / 3) / 10) * 10);
                                            break;
                                        default:
                                            setEditPrice(basePrice);
                                            break;
                                    }

                                    console.log("basePrice");
                                    console.log(basePrice);


                                    setRatio(event.target.value);
                                }
                                }
                                sx={{
                                    minHeight: 48,
                                    padding: '4px',
                                    borderRadius: '12px',
                                    bgcolor: 'neutral.softBg',
                                    '--RadioGroup-gap': '4px',
                                    '--Radio-actionRadius': '8px',
                                }}
                            >
                                {['수기입력', '1/3', '1/2', '2/3'].map((item) => (
                                    <Radio
                                        key={item}
                                        color="neutral"
                                        value={item}
                                        disableIcon
                                        label={item}
                                        variant="plain"
                                        sx={{ px: 2, alignItems: 'center' }}
                                        slotProps={{
                                            action: ({ checked }) => ({
                                                sx: {
                                                    ...(checked && {
                                                        bgcolor: 'background.surface',
                                                        boxShadow: 'sm',
                                                        '&:hover': {
                                                            bgcolor: 'background.surface',
                                                        },
                                                    }),
                                                },
                                            }),
                                        }}
                                    />
                                ))}
                            </RadioGroup>
                        </div>
                        <div>
                            <Input
                                fullWidth
                                type="text"
                                value={formatNumber(editPrice)}
                                onChange={(e) => {

                                    if (ratio !== "수기입력") {
                                        return;
                                    }

                                    const rawValue = e.target.value;
                                    const numericValue = unformatNumber(rawValue);

                                    if (!isNaN(numericValue)) {
                                        setEditPrice(numericValue);
                                    }
                                }}
                                endDecorator={<span>원</span>}
                            />
                        </div>
                        <div style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "24px"
                        }}>
                            <Button
                                variant="solid"
                                onClick={saveEditedPrice}
                                loading={editLoading}
                            >
                                수정하기
                            </Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>

            <Modal
                open={modalOpen5}
                onClose={handleClose5}
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: "none",
                            backgroundColor: "transparent",
                        },
                    },
                }}
            >
                <ModalDialog>
                    <div style={{
                        width: "300px"
                    }}>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "20px",
                            marginBottom: "12px"
                        }}>
                            결제선생 기한 설정
                        </div>
                        <div>
                            <Input
                                fullWidth
                                type="number"
                                value={due}
                                onChange={(e) => {
                                    setDue(+e.target.value);
                                }}
                                endDecorator={<span>일</span>}
                            />
                        </div>
                        <div style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "24px"
                        }}>
                            <Button
                                variant="solid"
                                onClick={sendPayTeacher}
                                loading={payLoading}
                            >
                                결제선생 발송
                            </Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>
            <Modal
                open={modalOpen4}
                onClose={handleClose4}
            >
                <ModalDialog>
                    <div style={{
                        width: "400px"
                    }}>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "20px",
                            marginBottom: "12px"
                        }}>
                            상품 추가하기 전송 내역
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "8px"
                        }}>
                            마지막 등원일 이후 수강권이 포함 되어 추가되지 않은 학생 목록
                        </div>
                        <div>
                            {afterLastDateUserInfos.length > 0 ? afterLastDateUserInfos.map((user, index) => {
                                return (
                                    <div key={index}>
                                        {user.name}({user.location})
                                    </div>
                                )
                            })
                                :
                                "없음"
                            }
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "8px",
                            marginTop: "16px"
                        }}>
                            이미 미납 상품 보유로 추가되지 않은 학생 목록
                        </div>
                        <div>
                            {alreadyHaveUserInfos.length > 0 ? alreadyHaveUserInfos.map((user, index) => {
                                return (
                                    <div key={index}>
                                        {user.name}({user.location})
                                    </div>
                                )
                            })
                                :
                                "없음"
                            }
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "8px",
                            marginTop: "16px"
                        }}>
                            중복 일자 상품 보유로 추가되지 않은 학생 목록
                        </div>
                        <div>
                            {duplicateUserInfos.length > 0 ? duplicateUserInfos.map((user, index) => {
                                return (
                                    <div key={index}>
                                        {user.name}({user.location})
                                    </div>
                                )
                            })
                                :
                                "없음"
                            }
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginTop: "16px",
                            marginBottom: "8px"
                        }}>
                            에러로 추가되지 않은 학생 목록
                        </div>
                        <div>
                            {errUserInfos.length > 0 ? errUserInfos.map((user, index) => {
                                return (
                                    <div key={index}>
                                        {user.name}({user.location})
                                    </div>
                                )
                            })
                                :
                                "없음"
                            }
                        </div>
                        <div style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "24px"
                        }}>
                            <Button
                                variant="solid"
                                color="neutral"
                                onClick={() => {

                                    const afterLastDateText =
                                        afterLastDateUserInfos.length > 0
                                            ? afterLastDateUserInfos
                                                .map(user => `${user.name}(${user.location})`)
                                                .join("\n")
                                            : "없음";

                                    const duplicateText =
                                        duplicateUserInfos.length > 0
                                            ? duplicateUserInfos
                                                .map(user => `${user.name}(${user.location})`)
                                                .join("\n")
                                            : "없음";

                                    const errorText =
                                        errUserInfos.length > 0
                                            ? errUserInfos
                                                .map(user => `${user.name}(${user.location})`)
                                                .join("\n")
                                            : "없음";

                                    const alreadyHaveUserInfosText =
                                        alreadyHaveUserInfos.length > 0
                                            ? alreadyHaveUserInfos
                                                .map(user => `${user.name}(${user.location})`)
                                                .join("\n")
                                            : "없음";

                                    const finalText =
                                        `마지막 등원일 이후 수강권이 포함 되어 추가되지 않은 학생 목록 : ${afterLastDateText} / 이미 미납 상품 보유로 추가되지 않은 학생 목록 : ${alreadyHaveUserInfosText} / 중복 일자 상품 보유로 추가되지 않은 학생 목록 : ${duplicateText} / 에러로 추가되지 않은 학생 목록 : ${errorText}`;

                                    navigator.clipboard.writeText(finalText);

                                    toast.success("클립보드에 복사되었습니다", {
                                        position: "bottom-right",
                                        autoClose: 3000,
                                        hideProgressBar: true,
                                        theme: "light"
                                    });
                                }}
                                sx={{
                                    marginRight: "8px"
                                }}
                            >
                                클립보드 복사
                            </Button>
                            <Button
                                variant="solid"
                                onClick={handleClose4}
                            >
                                확인
                            </Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>



        </div>
    )
}

export default ManagePayment;